import React from "react";
import { Box } from "@mui/material";
import QRCode from "react-qr-code";
import { useQuery } from "react-query";
import axios from "axios";
import MuPb from "../../widgets/MuPb";
import { getDbHeader } from "../../utils/util";
import { API_ENDPOINT } from "../../utils/constants"; // Ensure this import path is correct

export const EbadgeService = React.forwardRef((props, ref) => {
  const { user, isPreview = false } = props;

  // React Query integration for fetching the banner
  const { data, isLoading, isError, error } = useQuery(
    ["serviceBadgeBanner"],
    async () => {
      const response = await axios.get(
        `${API_ENDPOINT}/event/get-service-badge-banner`,
        getDbHeader()
      );
      return response.data;
    },
    {
      refetchOnWindowFocus: false, // Prevents refetching every time user switches tabs
      staleTime: 5 * 60 * 1000, // Caches the banner for 5 minutes
    }
  );

  const style = {
    badgeContainer: {
      marginTop: "16px",
      position: "relative",
      width: "9.5cm",
      height: "14cm",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      alignItems: "center",
      color: "black",
      padding: "1cm",
      boxSizing: "border-box",
      overflow: "hidden", // Ensures background image doesn't bleed out of bounds
    },
    detailsContainer: {
      textAlign: "center",
      marginTop: "4cm",
      width: "100%",
    },
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          width: "9.5cm",
          height: "14cm",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MuPb />
      </Box>
    );
  }

  if (isError) {
    console.error("Failed to load badge banner:", error);
    // You can return a fallback UI here if needed
  }

  return (
    <div ref={ref} style={style.badgeContainer}>
      <div style={style.detailsContainer}>
        {isPreview && data?.serviceBadgeBanner && (
          <img
            src={data.serviceBadgeBanner}
            alt="Badge Background"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
              objectFit: "cover",
            }}
          />
        )}
        <Box
          sx={{
            position: "absolute",
            top: "4.3cm",
            left: "1cm",
            right: "1cm",
            bottom: "1cm",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <Box mt={4} gap={4} display={"flex"}>
            <Box>
              <img
                alt="User Profile"
                style={{
                  height: "130px",
                  width: "130px",
                  objectFit: "contain",
                  backgroundColor: "#fff", // Gives contrast against background
                }}
                src={user?.photoUrl}
              />
            </Box>
            <Box sx={{ backgroundColor: "#fff", padding: "4px" }}>
              <QRCode value={user?.barcode_id || "N/A"} size={122} />
            </Box>
          </Box>
          <Box
            sx={{
              fontWeight: "bold",
              fontSize: "17px",
              mt: 2,
              textAlign: "center",
            }}
          >
            {user?.companyName?.toUpperCase()}
          </Box>
          <Box
            sx={{
              fontWeight: "bold",
              fontSize: "24px",
              mt: 1,
              textAlign: "center",
            }}
          >
            {user?.name?.toUpperCase()}
          </Box>
        </Box>
      </div>
    </div>
  );
});
